import { BRAND } from "@/lib/brand";

const MEMBERS = [
    {
        photoKey: "raul",
        name: "RAÚL HERRERO",
        role: "Fundador y AI Architect",
        bio: "Perfil multidisciplinar con formación en el Instituto Europeo de Alta Dirección. Científico de formación en química por la Universidad de Valladolid, la Università di Genova y la Universidad de Sevilla, con paso por el CSIC y posteriormente por el departamento de calidad de una de las bodegas de referencia de la denominación de origen Ribera del Duero. Los últimos ocho años dirigiendo exportaciones e importaciones, los últimos tres liderando la zona norte para una de las consultoras de comercio exterior más antiguas de España. Ha residido en cinco países y representado empresas en más de treinta, en cuatro continentes. MBA y Máster en IA for Business por el Instituto Superior Europeo de Barcelona, con varias menciones por Harvard Business Impact en su programa ejecutivo. Hoy lidera Aurum Vanguard junto a un equipo de profesionales que apuestan por la firma y sostienen el estándar de excelencia que esta nueva era agéntica exige para poder aportar valor real a los clientes y socios de la compañía.",
    },
    {
        photoKey: "omar",
        name: "OMAR AL-HASHMI",
        role: "Area Manager Golfo",
        bio: "Omán es un país donde la confianza se construye en una vida, no en una reunión. Omar Al-Hashmi creció dentro de esa lógica. Estudió ingeniería en Holanda — donde conoció de primera mano la innovación y la vanguardia de la industria tecnológica europea — y dedicó los años siguientes a la industria extractiva de petróleo y gas en su país natal, ahí donde los proyectos se miden en décadas. Aurum Vanguard tiene en él al socio que abre puertas institucionales que ninguna firma europea sabe siquiera cómo llamar. Es el puente entre dos mundos comerciales que rara vez se entienden bien. Lidera el desarrollo de Aurum Vanguard en todos los países del Golfo y comparte con Simei De la Vega la responsabilidad operativa de Emiratos.",
    },
    {
        photoKey: "sergio",
        name: "SERGIO RUBI",
        role: "Area Manager Europa y Reino Unido",
        bio: "Hay personas que entran en una industria nueva con la disciplina aprendida en otra. Sergio Rubi es una de ellas. Durante tres años se sumergió en el mundo del vino hasta convertirse en una voz de referencia en Irlanda en el posicionamiento y la sensibilización de la marca España en la gastronomía internacional. Hoy lleva ese mismo rigor — la lectura larga del cliente, la paciencia para que la conversación madure, el oficio del que vende lo que entiende — al despliegue de sistemas agénticos. Como Area Manager para Europa y Reino Unido, lidera la transformación tecnológica de negocios en Irlanda, España y el Reino Unido. La capacidad incansable de aprendizaje siempre fue su distintivo. Ahora también es el de Aurum.",
    },
    {
        photoKey: "simei",
        name: "SIMEI DE LA VEGA",
        role: "Area Manager Emiratos",
        bio: "Bilbaíno de familia siderúrgica. Generaciones forjando metal en una de las industrias más antiguas y exigentes de España — y de ahí su forma de mirar el trabajo: con precisión y con respeto. Simei De la Vega heredó ese rigor, pero decidió construirse en otra parte. Su primer año en una empresa estatal de los Emiratos Árabes Unidos le abrió las puertas a un ecosistema empresarial que muy pocos europeos consiguen leer bien. Decidió quedarse. Desde ahí lidera, como Area Manager de Emiratos, la expansión de Aurum Vanguard en uno de los mercados más estratégicos del mundo. Comparte con Sergio Rubi la atención al mercado ibérico cuando un cliente cruza entre ambos mundos.",
    },
];

function TeamCard({ m, i }) {
    const photo = BRAND.team[m.photoKey];
    return (
        <article
            data-testid={`team-card-${i}`}
            className="group bg-white border border-[#E5E0D5] flex flex-col hover:-translate-y-1 transition-transform duration-300"
        >
            <div className="relative aspect-[4/5] bg-[#1A1A1A] overflow-hidden">
                {photo ? (
                    <img
                        src={photo}
                        alt={`${m.name}, ${m.role}`}
                        loading="lazy"
                        className="absolute inset-0 w-full h-full object-cover grayscale-[15%] group-hover:grayscale-0 transition-all duration-700"
                    />
                ) : (
                    <div className="absolute inset-0 flex items-center justify-center text-center px-6 text-[#8B6914] text-xs tracking-[0.24em] uppercase">
                        [Photo placeholder — {m.name}]
                    </div>
                )}
                <div className="absolute bottom-0 left-0 right-0 h-px bg-[#8B6914]" />
            </div>
            <div className="p-6 md:p-8 flex-1 flex flex-col">
                <h3
                    className="text-sm tracking-[0.22em] uppercase text-[#8B6914]"
                    style={{ fontVariant: "small-caps" }}
                >
                    {m.name}
                </h3>
                <p className="mt-2 font-serif-display italic text-[#666666] text-base">
                    {m.role}
                </p>
                <p
                    className="mt-5 text-[15px] text-[#1A1A1A] leading-[1.7]"
                    style={{ fontFamily: "Georgia, 'Cormorant Garamond', serif" }}
                >
                    {m.bio}
                </p>
            </div>
        </article>
    );
}

export default function Team() {
    return (
        <section
            id="equipo"
            data-testid="team-section"
            className="bg-white py-28 md:py-40"
        >
            <div className="max-w-[1200px] mx-auto px-6 md:px-12">
                <div className="max-w-[820px]">
                    <h2 className="font-serif-display text-4xl md:text-6xl tracking-tight text-[#1A1A1A] leading-[1.05]">
                        Quiénes somos.
                    </h2>
                    <p className="mt-5 font-serif-display italic text-lg md:text-2xl text-[#666666]">
                        Cuatro personas. Diez años de relaciones. Una decisión común.
                    </p>
                </div>

                <div className="mt-16 md:mt-20 grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
                    {MEMBERS.map((m, i) => (
                        <TeamCard key={m.name} m={m} i={i} />
                    ))}
                </div>

                <div className="mt-20 flex flex-col items-center text-center">
                    <span className="block h-px w-12 bg-[#8B6914]" aria-hidden="true" />
                    <p className="mt-6 font-serif-display italic text-lg md:text-xl text-[#1A1A1A] max-w-[720px]">
                        Cuatro personas que llevan entre 8 y 10 años conociéndose o trabajando juntas.
                    </p>
                    <p className="mt-3 font-serif-display italic font-semibold text-xl md:text-2xl text-[#1A1A1A]">
                        No nos hemos contratado por LinkedIn. Nos hemos elegido.
                    </p>
                </div>
            </div>
        </section>
    );
}
